import { ClientDisplayableError, isErrorResponse } from '@standardnotes/responses';
export class DeleteSharedVault {
    constructor(sharedVaultServer, sync, deleteVault) {
        this.sharedVaultServer = sharedVaultServer;
        this.sync = sync;
        this.deleteVault = deleteVault;
    }
    async execute(params) {
        const response = await this.sharedVaultServer.deleteSharedVault({
            sharedVaultUuid: params.sharedVault.sharing.sharedVaultUuid,
        });
        if (isErrorResponse(response)) {
            return ClientDisplayableError.FromString(`Failed to delete vault ${JSON.stringify(response)}`);
        }
        await this.deleteVault.execute(params.sharedVault);
        await this.sync.sync();
    }
}
